<div class="pdf-page app-aul-006-24" id="aul00624">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large mb-0" style="text-align: center">
    <b>POLICYHOLDER DISCLOSURE NOTICE OF TERRORISM</b>
  </p>
  <p class="font-large" style="text-align: center"><b>INSURANCE COVERAGE</b></p>
  <br />
  <div class="font-small">
    <p>
      You are hereby notified that under the Terrorism Risk Insurance Act of
      2002, as amended ("TRIA"), that you have a right to purchase insurance
      coverage for losses arising out of acts of terrorism, as defined in
      Section 102(1) of the Act, as amended: The term “act of terrorism” means
      any act that is certified by the Secretary of the Treasury, in
      consultation with the Secretary of Homeland Security and the Attorney
      General of the United States, to be an act of terrorism; to be a violent
      act or an act that is dangerous to human life, property, or
      infrastructure; to have resulted in damage within the United States, or
      outside the United States in the case of an air carrier or vessel or the
      premises of a United States mission; and to have been committed by an
      individual or individuals, as part of an effort to coerce the civilian
      population of the United States or to influence the policy or affect the
      conduct of the United States Government by coercion. Any coverage you
      purchase for "acts of terrorism" shall expire at 12:00 midnight December
      31, 2027, the date on which the TRIA Program is scheduled to terminate, or
      the expiry date of the policy whichever occurs first, and shall not cover
      any losses or events which arise after the earlier of these dates.
    </p>

    <p>
      YOU SHOULD KNOW THAT COVERAGE PROVIDED BY THIS POLICY FOR LOSSES CAUSED BY
      CERTIFIED ACTS OF TERRORISM IS PARTIALLY REIMBURSED BY THE UNITED STATES
      UNDER A FORMULA ESTABLISHED BY FEDERAL LAW. HOWEVER, YOUR POLICY MAY
      CONTAIN OTHER EXCLUSIONS WHICH MIGHT AFFECT YOUR COVERAGE, SUCH AS AN
      EXCLUSION FOR NUCLEAR EVENTS. UNDER THIS FORMULA, THE UNITED STATES PAYS
      80% OF COVERED TERRORISM LOSSES EXCEEDING THE STATUTORILY ESTABLISHED
      DEDUCTIBLE PAID BY THE INSURER(S) PROVIDING THE COVERAGE. YOU SHOULD ALSO
      KNOW THAT THE TERRORISM RISK INSURANCE ACT, AS AMENDED, CONTAINS A USD100
      BILLION CAP THAT LIMITS U.S. GOVERNMENT REIMBURSEMENT AS WELL AS INSURERS'
      LIABILITY FOR LOSSES RESULTING FROM CERTIFIED ACTS OF TERRORISM WHEN THE
      AMOUNT OF SUCH LOSSES IN ANY ONE CALENDAR YEAR EXCEEDS USD100 BILLION. IF
      THE AGGREGATE INSURED LOSSES FOR ALL INSURERS EXCEED USD100 BILLION, YOUR
      COVERAGE MAY BE REDUCED.
    </p>

    <p>
      THE PREMIUM CHARGED FOR THIS COVERAGE IS PROVIDED IN THE QUOTE COMMON
      POLICY DECLARATIONS ATTACHED AND DOES NOT INCLUDE ANY CHARGES FOR THE
      PORTION OF LOSS COVERED BY THE FEDERAL GOVERNMENT UNDER THE ACT.
    </p>

    <br />
    <br />

    <p>
      <b>
        IN ACCORDANCE WITH THE ACT, YOU MUST ELECT TO PURCHASE OR REJECT
        COVERAGE FOR ACTS OF TERRORISM. THIS POLICY INCLUDES OR EXCLUDES TRIA
        COVERAGE BASED ON THE ELECTION MADE BY YOU TO YOUR AGENT AND CONFIRMED
        BY YOU FOLLOWING POLICY ISSUANCE.
      </b>
    </p>
  </div>
</div>
